import clsx from 'clsx';
import React, { useState } from 'react';

import { create_bookmark_path, destroy_bookmark_path } from '../../routes';
import Modal from '../Referral/Modal';
import styles from './styles.module.scss';

const ShareNav = ({
  articleHighlight,
  articleSlug,
  briefingSlug,
  isPageBookmarked,
  referralUrl,
  title,
}: {
  articleHighlight?: string;
  articleSlug?: string;
  briefingSlug?: string;
  isPageBookmarked?: boolean;
  referralUrl: string;
  title?: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const shareModalCover = document.querySelector<HTMLElement>('.share-modal-cover');
  const shareModalContainer = document.querySelector<HTMLElement>('.share-modal-container');

  const triggerModal = () => {
    /* Todo this is not react way to trigger modal, however since Article share modal is written in HTML and Vanaila Javascript, we need to trigger by javascript only. Need to covert this to React way once Article share Modal move to React */
    shareModalContainer.style.display = 'block';
    shareModalCover.style.display = 'block';
  };

  return (
    <>
      <Modal isOpen={isOpen} onClose={() => setIsOpen(false)} referralUrl={referralUrl} />
      <div className={styles.stickyHeaderContainer}>
        <div className="row">
          <div className="col-sm-12">
            <div className={styles.container}>
              <div className={styles.titleContainer}>
                <span className={styles.highlight}>{articleHighlight}</span>
                {articleHighlight && title && <span>{` `}</span>}
                <span className={styles.title}>{title}</span>
              </div>
              <div className={styles.actionContainer}>
                {(articleSlug || briefingSlug) && (
                  <div className={styles.infoBookmark}>
                    <a
                      href={
                        isPageBookmarked
                          ? destroy_bookmark_path(
                              articleSlug
                                ? { article: articleSlug, remote: true }
                                : { briefing: briefingSlug, remote: true }
                            )
                          : create_bookmark_path(
                              articleSlug
                                ? { article: articleSlug, remote: true }
                                : { briefing: briefingSlug, remote: true }
                            )
                      }
                    >
                      <i
                        className={`fa fa-bookmark ${isPageBookmarked ? 'is-bookmarked' : ''}`}
                      ></i>
                    </a>
                  </div>
                )}
                {articleSlug && (
                  <button
                    className={clsx(styles.shareArticleBtn, 'share-modal-button')}
                    onClick={triggerModal}
                  >
                    Share article
                  </button>
                )}
                <button className={styles.referralBtn} onClick={() => setIsOpen(!isOpen)}>
                  Refer a friend
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShareNav;
